module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gdzh6"))).then(() => module.bundle.root('jnagv'));